function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * CanvasAnnotationDisplay - class used to display a SVG and fragment based
 * annotations.
 */
var CanvasAnnotationDisplay =
/*#__PURE__*/
function () {
  /** */
  function CanvasAnnotationDisplay(_ref) {
    var resource = _ref.resource,
        color = _ref.color,
        zoom = _ref.zoom,
        offset = _ref.offset;

    _classCallCheck(this, CanvasAnnotationDisplay);

    this.resource = resource;
    this.color = color;
    this.zoom = zoom;
    this.offset = offset;
  }
  /** */


  _createClass(CanvasAnnotationDisplay, [{
    key: "toContext",
    value: function toContext(context) {
      if (this.resource.svgSelector) {
        this.svgContext(context);
      } else {
        this.fragmentContext(context);
      }
    }
    /** */

  }, {
    key: "svgContext",

    /** */
    value: function svgContext(context) {
      var _this = this;

      _toConsumableArray(this.svgPaths).forEach(function (element) {
        /**
         *  Note: Path2D is not supported in IE11.
         *  TODO: Support multi canvas offset
         *  One example: https://developer.mozilla.org/en-US/docs/Web/API/Path2D/addPath
         */
        var p = new Path2D(element.attributes.d.nodeValue);
        /**
         * Note: we could do something to return the svg styling attributes as
         * some have encoded information in these values. However, how should we
         * handle highlighting and other complications?
         *  context.strokeStyle = element.attributes.stroke.nodeValue;
         *  context.lineWidth = element.attributes['stroke-width'].nodeValue;
         */

        context.strokeStyle = _this.color; // eslint-disable-line no-param-reassign

        context.lineWidth = _this.lineWidth(); // eslint-disable-line no-param-reassign

        context.stroke(p);
      });
    }
    /** */

  }, {
    key: "fragmentContext",
    value: function fragmentContext(context) {
      var fragment = this.resource.fragmentSelector;
      fragment[0] += this.offset.x;
      context.strokeStyle = this.color; // eslint-disable-line no-param-reassign

      context.lineWidth = this.lineWidth(); // eslint-disable-line no-param-reassign

      context.strokeRect.apply(context, _toConsumableArray(fragment));
    }
    /** */

  }, {
    key: "lineWidth",
    value: function lineWidth() {
      return Math.ceil(1 / (this.zoom * 100));
    }
    /** */

  }, {
    key: "svgString",
    get: function get() {
      return this.resource.svgSelector.value;
    }
  }, {
    key: "svgPaths",
    get: function get() {
      var parser = new DOMParser();
      var xmlDoc = parser.parseFromString(this.svgString, 'text/xml');
      return xmlDoc.getElementsByTagName('path');
    }
  }]);

  return CanvasAnnotationDisplay;
}();

export { CanvasAnnotationDisplay as default };